import {
  FilterMode,
  ShowcaseLine_OrderBy,
  ShowcaseLine,
  SortOrder,
  ShowcaseLine_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const showcaseLineService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.showcaseLineOne({ id });
    return result.showcaseLineOne as ShowcaseLine;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: ShowcaseLine_OrderBy[] | null = null,
    filter: ShowcaseLine_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: ShowcaseLine_Filter | undefined;
    if (searchValue !== "") {
      where = {
        concept: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.showcaseLineListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ concept: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.showcaseLineListWithOffset
    ) as ShowcaseLine[];
    return { list, orderBy };
  },
};
